module.exports = __webpack_public_path__ + "static/media/icon-pag-pix.20b6816f.svg";